import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Grid, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { FnDialog, I18n, ParseHtml, formatNumber } from 'utilities/utilities';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled } from '@mui/material';
import "./../../StyleProject.css";
import { List as LINQ } from "linqts";
import { parseFloatCheckValue } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ModalScoringCriteria = ({ isOpen, setIsOpen, ObjData, }) => { //Pop Up > รายละเอียดการให้คะแนน

    const [sSubCommitteeName, setsSubCommitteeName] = useState(null);
    const [lstScoringCriteria, setlstScoringCriteria] = useState([]);

    const [nSum_nFullScore, setnSum_nFullScore] = useState(null);
    const [nSum_nScore, setnSum_nScore] = useState(null);
    const [nSum_nFullWeight, setnSum_nFullWeight] = useState(null);
    const [nSum_nWeightScore, setnSum_nWeightScore] = useState(null);

    useEffect(() => {
        if (isOpen && ObjData) {
            setsSubCommitteeName(ObjData?.sSubCommitteeName);
            let lstData = ObjData?.lstScoringCriteria ?? [];
            setlstScoringCriteria(lstData);

            setnSum_nFullScore(new LINQ<any>(lstData || []).Sum(s => parseFloatCheckValue(s.nFullScore)) ?? null);
            setnSum_nScore(new LINQ<any>(lstData || []).Sum(s => parseFloatCheckValue(s.nScore)) ?? null);
            setnSum_nFullWeight(new LINQ<any>(lstData || []).Sum(s => parseFloatCheckValue(s.nFullWeight)) ?? null);
            setnSum_nWeightScore(new LINQ<any>(lstData || []).Sum(s => parseFloatCheckValue(s.nWeightScore)) ?? null);
        }
    }, [isOpen, ObjData])

    const handleClose = () => {
        setIsOpen(false);
    }

    return (
        <DialogPreview
            IsOpen={isOpen}
            Title={"รายละเอียดการให้คะแนน " + (sSubCommitteeName ?? "")}
            required={false}
            sMaxWidth="lg"
            onClose={handleClose}
            JsxDialogAction
        >
            <Grid container spacing={1} justifyContent={"start"} alignItems={"start"} style={{ padding: '1%', paddingTop: '2% !important', }}>
                <TableContainer id='table-ScoringCriteria' component={Paper}>
                    <Table sx={{ minWidth: 1000 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" padding='none' style={{ minWidth: '220px', width: '220px' }} >เกณฑ์การให้คะแนน</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >คะแนนเต็ม</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >คะแนนที่ได้</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >{ParseHtml("คะแนนเต็ม <br/>(คิดค่าน้ำหนัก)")}</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >{ParseHtml("คะแนนที่ได้ <br/>(คิดค่าน้ำหนัก)")}</TableCell>
                            </TableRow>
                        </TableHead>  
                            {(lstScoringCriteria || []).length === 0 ?
                                <StyledTableRow key={`sID_ScoringCriteria_`}>
                                    <TableCell align="center" colSpan={6} style={{ padding: '3%' }}>ไม่พบข้อมูล</TableCell>
                                </StyledTableRow>
                                :
                                <TableBody>
                                    {(lstScoringCriteria || []).map((iCriteria) => {
                                        return (
                                            <TableRow key={`sID_ScoringCriteria_${iCriteria.nCriteriaID}`}>
                                                <TableCell align="left">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iCriteria.sCriteria + "")}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{formatNumber(iCriteria.nFullScore, 0)}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{formatNumber(iCriteria.nScore, 0)}</Typography>
                                                    </Grid>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{formatNumber(iCriteria.nFullWeight, 2)}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{formatNumber(iCriteria.nWeightScore, 2)}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                            </TableRow>                                            
                                        )
                                    })}
                                    <TableRow key={`sID_ScoringCriteria_Sum`}>
                                        <TableCell className='bg-color' align="center">รวม</TableCell>
                                        <TableCell className='bg-color' align="center">{formatNumber(nSum_nFullScore, 0)}</TableCell>
                                        <TableCell className='bg-color' align="center">{formatNumber(nSum_nScore, 0)}</TableCell>
                                        <TableCell className='bg-color' align="center">{formatNumber(nSum_nFullWeight, 2)}</TableCell>
                                        <TableCell className='bg-color' align="center">{formatNumber(nSum_nWeightScore, 2)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            }                    
                    </Table>
                </TableContainer>
            </Grid>
        </DialogPreview>
    )
}

export default ModalScoringCriteria
